<template>

</template>

<script>
  const UrlPrefix="/api_"+getQueryVariable("apiurl");
  const CompanyName=getQueryVariable("apicom");

  function getQueryVariable(variable){
    //https://mes-wx.51zhaobu.com/#/?Token=fbf99ed9-ef90-4ce1-a829-7a9dfb928f11&CompanyName=zhimeixing&ServerName=s1
    let result='';
    var query = window.location.href.split("?")[1];
    if(query!=undefined && query!=null){
     // query=query.replace("#/","").replaceAll("%3A",":").replaceAll("%2F","/");
      query.replace("#/","");
      console.log("参数："+query)
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){
          result= pair[1];
          if(result!=null && result!=undefined && result!='') {
            console.log(variable+":"+result+"，存入缓存！")
            localStorage.setItem(variable, result);//存入缓存中
          }
          break;
        }
      }
      result='';
    }else{
      result=''
    }
    if(result=='' || result==undefined || result==null){
      const paramValue=localStorage.getItem(variable);
      if(paramValue!=undefined && paramValue!=null && paramValue!='' && paramValue!=false){
        console.log(variable+":"+paramValue+"，取出缓存！")
        return paramValue;
      }else{
        return '';
      }
    }
  }
    export default {
      UrlPrefix,
      CompanyName,
      getQueryVariable,
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Utils.vue